export const ideas = [
  {
    name: 'Basics',
    IdeaIcon: 'basics',
    description:
      'The basic information about your life that you want to keep track of - stuff like money, food, home, transportation, and other necessities ' +
      'of life. Also, as you make efforts to master the basic skills that you need to take care of your famiy (a life-long journey!), use this ' +
      'category to reach out for help for and to celebrate those skills.',
    ideas: [
      {
        title: 'A basic',
        tags: ['basics'],
      },
      {
        title: 'A recipe',
        tags: ['basics', 'recipe'],
      },
      {
        title: 'Adulting skills: I am learning to/I can...',
        tags: ['basics', 'skills', 'adulting'],
      },
      {
        title: 'An important document',
        tags: ['basics', 'document', 'important'],
      },
      {
        title: "Food skills: I'm learning to/I can...",
        tags: ['basics', 'skills', 'food'],
      },
      {
        title: "Home-making skills: I'm learning to/I can...",
        tags: ['basics', 'skills', 'home'],
      },
      {
        title: 'House record',
        tags: ['basics', 'house record'],
      },
      {
        title: 'ID',
        tags: ['basics', 'document', 'id'],
      },
      {
        title: "Job skills: I'm learning to/I can...",
        tags: ['basics', 'skills', 'job'],
      },
      {
        title: 'License',
        tags: ['basics', 'document', 'license'],
      },
      {
        title: 'Life skills',
        tags: ['basics', 'skills', 'life'],
      },
      {
        title: 'Money skills',
        tags: ['basics', 'skills', 'money'],
      },
      {
        title: 'Organization skills',
        tags: ['basics', 'skills', 'organization'],
      },
      {
        title: 'Parenting skills',
        tags: ['basics', 'skills', 'parenting'],
      },
      {
        title: 'Passport',
        tags: ['basics', 'document', 'passport'],
      },
      {
        title: 'People that help',
        tags: ['basics', 'people-help'],
      },
      {
        title: 'People that help - food',
        tags: ['basics', 'people-help', 'food'],
      },
      {
        title: 'People that help - home',
        tags: ['basics', 'people-help', 'home'],
      },
      {
        title: 'People that help - life',
        tags: ['basics', 'people-help', 'life'],
      },
      {
        title: 'People that help - money',
        tags: ['basics', 'people-help', 'money'],
      },
      {
        title: 'People that help - vehicle',
        tags: ['basics', 'peoplehelp', 'vehicle'],
      },
      {
        title: 'Pet record',
        tags: ['basics', 'record', 'pet'],
      },
      {
        title: 'Public transportation skills',
        tags: ['basics', 'skills', 'public transportation'],
      },
      {
        title: 'Resume',
        tags: ['basics', 'document', 'resume'],
      },
      {
        title: 'School ID',
        tags: ['basics', 'document', 'school id'],
      },
      {
        title: 'Service record - vehicle',
        tags: ['basics', 'record', 'service', 'vehicle'],
      },
      {
        title: 'Service record - home',
        tags: ['basics', 'record', 'service', 'home'],
      },
      {
        title: 'Tax skills',
        tags: ['basics', 'skills', 'taxes'],
      },
      {
        title: 'Technology skills',
        tags: ['basics', 'skills', 'technology'],
      },
      {
        title: 'Time management skills',
        tags: ['basics', 'skills', 'time management'],
      },
      {
        title: 'Vehicle record',
        tags: ['basics', 'record', 'vehicle'],
      },
      {
        title: "Voting skills: I'm learning to/I can...",
        tags: ['basics', 'skills', 'voting'],
      },
    ],
  },
  {
    name: 'Bigs',
    IdeaIcon: 'bigs',
    description: 'The big memories, experiences, decisions and moments that, if you were to write your life story, need to be told.',
    ideas: [
      {
        title: 'A big',
        tags: ['bigs'],
      },
      {
        title: 'A big question',
        tags: ['bigs', 'question'],
      },
      {
        title: 'A breakthrough',
        tags: ['bigs', 'breakthrough'],
      },
      {
        title: 'A change',
        tags: ['bigs', 'change'],
      },
      {
        title: 'A decision',
        tags: ['bigs', 'decision'],
      },
      {
        title: 'A failure',
        tags: ['bigs', 'failure'],
      },
      {
        title: 'A family big',
        tags: ['bigs', 'family'],
      },
      {
        title: 'A family milestone',
        tags: ['bigs', 'family', 'milestone'],
      },
      {
        title: 'A family transition',
        tags: ['bigs', 'family', 'transition'],
      },
      {
        title: 'A first',
        tags: ['bigs', 'first'],
      },
      {
        title: 'A loss',
        tags: ['bigs', 'loss'],
      },
      {
        title: 'A meaningful memory',
        tags: ['bigs', 'memory'],
      },
      {
        title: 'A milestone',
        tags: ['bigs', 'milestone'],
      },
      {
        title: 'A move',
        tags: ['bigs', 'move'],
      },
      {
        title: 'A personal achievement',
        tags: ['bigs', 'personal achievment'],
      },
      {
        title: 'A personal transition',
        tags: ['bigs', 'transition'],
      },
      {
        title: 'A setback',
        tags: ['bigs', 'setback'],
      },
      {
        title: 'A strength',
        tags: ['bigs', 'strength'],
      },
      {
        title: 'A success',
        tags: ['bigs', 'success'],
      },
      {
        title: 'A time I showed I was strong',
        tags: ['bigs', 'strong'],
      },
      {
        title: 'A time my community showed we were strong',
        tags: ['bigs', 'community', 'strong'],
      },
      {
        title: 'A time my family showed we were strong',
        tags: ['bigs', 'family', 'strong'],
      },
      {
        title: 'A transition',
        tags: ['bigs', 'transition'],
      },
      {
        title: 'A turning point',
        tags: ['bigs', 'turning point'],
      },
      {
        title: 'A fun memory',
        tags: ['bigs', 'fun'],
      },
      {
        title: 'A win',
        tags: ['bigs', 'win'],
      },
      {
        title: 'An accomplishment',
        tags: ['bigs', 'accomplishment'],
      },
      {
        title: 'An achievement',
        tags: ['bigs', 'achievement'],
      },
      {
        title: 'An award',
        tags: ['bigs', 'award'],
      },
      {
        title: 'An historic event',
        tags: ['bigs', 'history'],
      },
      {
        title: 'An important date',
        tags: ['bigs', 'date'],
      },
      {
        title: 'I started crawling',
        tags: ['bigs', 'baby milestone', 'crawling'],
      },
      {
        title: 'My first word ',
        tags: ['bigs', 'baby milestone', 'firstword'],
      },
      {
        title: 'New tooth',
        tags: ['bigs', 'baby milestone', 'newtooth'],
      },
      {
        title: 'Something I want to add to my bucket list',
        tags: ['bigs', 'bucket list'],
      },
      {
        title: 'Something on my bucket list that I did',
        tags: ['bigs', 'bucket list ✓'],
      },
      {
        title: 'Something that had a big impact on me',
        tags: ['bigs', 'impact'],
      },
      {
        title: 'The birth of someone important to me',
        tags: ['bigs', 'birth'],
      },
      {
        title: 'The death of someone important to me',
        tags: ['bigs', 'death'],
      },
    ],
  },
  {
    name: 'Birthdays',
    IdeaIcon: 'birthday',
    description:
      'Celebrate your birthday and reflect on your life every year. Where were you on your birthday, what’d you do, who was there? What family ' +
      'and cultural rituals did you include? What stands out to you as you grow another year older? Happy birthday!',
    ideas: [
      {
        title: 'A birthday',
        tags: ['birthdays'],
      },
      {
        title: 'Birthday gift',
        tags: ['birthdays', 'birthday gift'],
      },
      {
        title: 'Birthday party',
        tags: ['birthdays', 'birthday party'],
      },
      {
        title: 'Birthday rituals',
        tags: ['birthdays', 'birthday ritual'],
      },
      {
        title: 'My birthday',
        tags: ['birthdays'],
      },
      {
        title: 'My golden birthday',
        tags: ['birthdays', 'golden birthday'],
      },
      {
        title: 'When I turned one',
        tags: ['birthdays', 'one year old'],
      },
      {
        title: 'When I turned two',
        tags: ['birthdays', 'two years old'],
      },
      {
        title: 'When I turned three',
        tags: ['birthdays', 'three years old'],
      },
      {
        title: 'When I turned four',
        tags: ['birthdays', 'four years old'],
      },
      {
        title: 'When I turned five',
        tags: ['birthdays', 'five years old'],
      },
      {
        title: 'When I turned six',
        tags: ['birthdays', 'six years old'],
      },
      {
        title: 'When I turned seven',
        tags: ['birthdays', 'seven years old'],
      },
      {
        title: 'When I turned eight',
        tags: ['birthdays', 'eight years old'],
      },
      {
        title: 'When I turned nine',
        tags: ['birthdays', 'nine years old'],
      },
      {
        title: 'When I turned ten',
        tags: ['birthdays', 'ten years old'],
      },
      {
        title: 'When I turned sixteen',
        tags: ['birthdays', 'sixteen years old'],
      },
      {
        title: 'When I turned eighteen',
        tags: ['birthdays', 'eighteen years old'],
      },
      {
        title: 'When I turned twenty',
        tags: ['birthdays', 'twenty years old'],
      },
      {
        title: 'When I turned twenty-one',
        tags: ['birthdays', 'twenty-one years old'],
      },
      {
        title: 'When I turned thirty',
        tags: ['birthdays', 'thirty years old'],
      },
      {
        title: 'When I turned forty',
        tags: ['birthdays', 'forty years old'],
      },
      {
        title: 'When I turned fifty',
        tags: ['birthdays', 'fifty years old'],
      },
      {
        title: 'When I turned sixty',
        tags: ['birthdays', 'sixty years old'],
      },
      {
        title: 'When I turned seventy',
        tags: ['birthdays', 'seventy years old'],
      },
      {
        title: 'When I turned eighty',
        tags: ['birthdays', 'eighty years old'],
      },
      {
        title: 'When I turned ninety',
        tags: ['birthdays', 'ninety years old'],
      },
      {
        title: 'When I turned one hundred',
        tags: ['birthdays', 'one hundred years old'],
      },
      {
        title: 'When I turned...',
        tags: ['birthdays'],
      },
    ],
  },
  {
    name: 'Celebrations',
    IdeaIcon: 'celebrations',
    description: 'The celebrations, holidays, rituals, special events and other memories that mean the most to you and the people you love.',
    ideas: [
      {
        title: 'A celebration',
        tags: ['celebrations'],
      },
      {
        title: 'A baptism',
        tags: ['celebrations', 'baptism'],
      },
      {
        title: 'A bar mitzvah',
        tags: ['celebrations', 'bar mitzvah'],
      },
      {
        title: 'A bat mitzvah',
        tags: ['celebrations', 'bat mitzvah'],
      },
      {
        title: 'A celebration of life',
        tags: ['celebrations', 'life'],
      },
      {
        title: 'A celebration of new life',
        tags: ['celebrations', 'new life'],
      },
      {
        title: 'A celebration with friends',
        tags: ['celebrations', 'friends'],
      },
      {
        title: 'A community celebration',
        tags: ['celebrations', 'community'],
      },
      {
        title: 'A family celebration',
        tags: ['celebrations', 'family'],
      },
      {
        title: 'Family celebration foods',
        tags: ['celebrations', 'family', 'food'],
      },
      {
        title: 'A graduation ceremony',
        tags: ['celebrations', 'graduation'],
      },
      {
        title: 'A holiday',
        tags: ['celebrations', 'holiday'],
      },
      {
        title: 'A memorial service',
        tags: ['celebrations', 'memorial service'],
      },
      {
        title: 'A milestone to celebrate',
        tags: ['celebrations', 'milestone'],
      },
      {
        title: 'A naming ceremony',
        tags: ['celebrations', 'naming ceremony'],
      },
      {
        title: 'A national celebration',
        tags: ['celebrations', 'national'],
      },
      {
        title: 'A party',
        tags: ['celebrations', 'party'],
      },
      {
        title: 'A personal celebration',
        tags: ['celebrations', 'personal'],
      },
      {
        title: 'a quiet celebration',
        tags: ['celebrations', 'quiet'],
      },
      {
        title: 'A wedding',
        tags: ['celebrations', 'wedding'],
      },
      {
        title: 'An anniversary',
        tags: ['celebrations', 'anniversary'],
      },
      {
        title: 'An award ceremony',
        tags: ['celebrations', 'award'],
      },
      {
        title: 'Ashura',
        tags: ['celebrations', 'holiday', 'ashura'],
      },
      {
        title: 'Christmas',
        tags: ['celebrations', 'holiday', 'christmas'],
      },
      {
        title: 'Cinco de Mayo',
        tags: ['celebrations', 'holiday', 'cinco de mayo'],
      },
      {
        title: 'Diwali',
        tags: ['celebrations', 'holiday', 'diwali'],
      },
      {
        title: 'Easter',
        tags: ['celebrations', 'holiday', 'easter'],
      },
      {
        title: 'Eid al-Fitr',
        tags: ['celebrations', 'holiday', 'eid al-fitr'],
      },
      {
        title: "Father's Day",
        tags: ['celebrations', 'holiday', "father's day"],
      },
      {
        title: 'Fourth of July',
        tags: ['celebrations', 'holiday', '4th of july'],
      },
      {
        title: 'Halloween',
        tags: ['celebrations', 'holiday', 'halloween'],
      },
      {
        title: 'Hanukkah',
        tags: ['celebrations', 'holiday', 'hanukkah'],
      },
      {
        title: 'Holi',
        tags: ['celebrations', 'holiday', 'holi'],
      },
      {
        title: 'Inauguration Day',
        tags: ['celebrations', 'inauguration'],
      },
      {
        title: "Indigenous Peoples' Day",
        tags: ['celebrations', 'holiday', "indigenous peoples' day"],
      },
      {
        title: 'Juneteenth',
        tags: ['celebrations', 'holiday', 'juneteenth'],
      },
      {
        title: 'Kwanzaa',
        tags: ['celebrations', 'holiday', 'kwanzaa'],
      },
      {
        title: 'Labor Day',
        tags: ['celebrations', 'holiday', 'labor day'],
      },
      {
        title: 'Martin Luther King, Jr. Day',
        tags: ['celebrations', 'holiday', 'mlk day'],
      },
      {
        title: 'Memorial Day',
        tags: ['celebrations', 'holiday', 'memorial day'],
      },
      {
        title: "Mother's Day",
        tags: ['celebrations', 'holiday', "mother's day"],
      },
      {
        title: "New Year's Celebration",
        tags: ['celebrations', 'holiday', 'new years'],
      },
      {
        title: 'Passover',
        tags: ['celebrations', 'holiday', 'passover'],
      },
      {
        title: 'Ramadan',
        tags: ['celebrations', 'holiday', 'ramadan'],
      },
      {
        title: 'Rosh Hashana',
        tags: ['celebrations', 'holiday', 'rosh hashana'],
      },
      {
        title: "St. Patrick's Day",
        tags: ['celebrations', 'holiday', "st patrick's day"],
      },
      {
        title: 'Thanksgiving',
        tags: ['celebrations', 'holiday', 'thanksgiving'],
      },
      {
        title: "Valentine's Day",
        tags: ['celebrations', 'holiday', "valentine's day"],
      },
      {
        title: "Veteran's Day",
        tags: ['celebrations', 'holiday', "veteran's day"],
      },
      {
        title: 'Yom Kippur',
        tags: ['celebrations', 'holiday', 'yom kippur'],
      },
    ],
  },
  {
    name: 'Faves',
    IdeaIcon: 'faves',
    description: 'Here’s where you record all of your favorite things. It’ll be fun over time to see what you and your family and friends love!',
    ideas: [
      {
        title: 'A favorite',
        tags: ['faves'],
      },
      {
        title: 'A family favorite',
        tags: ['faves', 'family'],
      },
      {
        title: 'Activity to do together',
        tags: ['faves', 'together activity'],
      },
      {
        title: 'Actor',
        tags: ['faves', 'actor'],
      },
      {
        title: 'Animal',
        tags: ['faves', 'animal'],
      },
      {
        title: 'Artist',
        tags: ['faves', 'artist'],
      },
      {
        title: 'Band',
        tags: ['faves', 'band'],
      },
      {
        title: 'Beach',
        tags: ['faves', 'beach'],
      },
      {
        title: 'Book',
        tags: ['faves', 'book'],
      },
      {
        title: 'Breakfast',
        tags: ['faves', 'breakfast'],
      },
      {
        title: 'Camping spot',
        tags: ['faves', 'camping'],
      },
      {
        title: 'City',
        tags: ['faves', 'city'],
      },
      {
        title: 'Color',
        tags: ['faves', 'color'],
      },
      {
        title: 'Concert',
        tags: ['faves', 'concert'],
      },
      {
        title: 'Dessert',
        tags: ['faves', 'dessert'],
      },
      {
        title: 'Dinner',
        tags: ['faves', 'dinner'],
      },
      {
        title: 'Drink',
        tags: ['faves', 'drink'],
      },
      {
        title: 'Family activity to do together',
        tags: ['faves', 'family activity'],
      },
      {
        title: 'Flower',
        tags: ['faves', 'flower'],
      },
      {
        title: 'Food',
        tags: ['faves', 'food'],
      },
      {
        title: 'Game',
        tags: ['faves', 'game'],
      },
      {
        title: 'Hike',
        tags: ['faves', 'hike'],
      },
      {
        title: 'Historical figure',
        tags: ['faves', 'history'],
      },
      {
        title: 'Holiday',
        tags: ['faves', 'holiday'],
      },
      {
        title: 'Ice cream',
        tags: ['faves', 'ice cream'],
      },
      {
        title: 'Lunch',
        tags: ['faves', 'lunch'],
      },
      {
        title: 'Memory',
        tags: ['faves', 'memory'],
      },
      {
        title: 'memory we shared',
        tags: ['faves', 'shared memory'],
      },
      {
        title: 'Mountain',
        tags: ['faves', 'mountain'],
      },
      {
        title: 'Movie',
        tags: ['faves', 'movie'],
      },
      {
        title: 'Music album',
        tags: ['faves', 'music album'],
      },
      {
        title: 'music artist',
        tags: ['faves', 'music artist'],
      },
      {
        title: 'One of our favorite...',
        tags: ['faves', 'we'],
      },
      {
        title: 'Organization',
        tags: ['faves', 'organization'],
      },
      {
        title: 'Piece of clothing',
        tags: ['faves', 'clothing'],
      },
      {
        title: 'Political person',
        tags: ['faves', 'political person'],
      },
      {
        title: 'Quote',
        tags: ['faves', 'quote'],
      },
      {
        title: 'Recipe',
        tags: ['faves', 'recipe'],
      },
      {
        title: 'Restaurant',
        tags: ['faves', 'restaurant'],
      },
      {
        title: 'Snack',
        tags: ['faves', 'snack'],
      },
      {
        title: 'Song',
        tags: ['faves', 'song'],
      },
      {
        title: 'Sport to play',
        tags: ['faves', 'sport to play'],
      },
      {
        title: 'Sport to watch',
        tags: ['faves', 'sport to watch'],
      },
      {
        title: 'Stuffed animal',
        tags: ['faves', 'stuffed animal'],
      },
      {
        title: 'Subject in school',
        tags: ['faves', 'school subject'],
      },
      {
        title: 'Teacher',
        tags: ['faves', 'teacher'],
      },
      {
        title: 'Team',
        tags: ['faves', 'team'],
      },
      {
        title: 'Toy',
        tags: ['faves', 'toy'],
      },
      {
        title: 'Treat',
        tags: ['faves', 'treat'],
      },
      {
        title: 'Tree',
        tags: ['faves', 'tree'],
      },
      {
        title: 'TV show',
        tags: ['faves', 'tv show'],
      },
      {
        title: 'Verse',
        tags: ['faves', 'verse'],
      },
      {
        title: 'Writer',
        tags: ['faves', 'writer'],
      },
    ],
  },
  {
    name: 'Fitness',
    IdeaIcon: 'fitness',
    description: 'Your sports and fitness experiences, and anything or any changes that impact your physical fitness.',
    ideas: [
      {
        title: 'Fitness',
        tags: ['fitness'],
      },
      {
        title: 'A bike ride',
        tags: ['fitness', 'bike'],
      },
      {
        title: 'A book',
        tags: ['fitness', 'book'],
      },
      {
        title: 'A game',
        tags: ['fitness', 'game'],
      },
      {
        title: 'A milestone',
        tags: ['fitness', 'milestone'],
      },
      {
        title: 'A movie',
        tags: ['fitness', 'movie'],
      },
      {
        title: 'A race',
        tags: ['fitness', 'race'],
      },
      {
        title: 'A run',
        tags: ['fitness', 'running'],
      },
      {
        title: 'A sport I am interested in',
        tags: ['fitness', 'sport'],
      },
      {
        title: 'A sporting event',
        tags: ['fitness', 'sporting event'],
      },
      {
        title: 'A sports award',
        tags: ['fitness', 'sports award'],
      },
      {
        title: 'A sports injury',
        tags: ['fitness', 'sports injury'],
      },
      {
        title: 'A walk',
        tags: ['fitness', 'walk'],
      },
      {
        title: 'An accomplishment',
        tags: ['fitness', 'accomplishment'],
      },
      {
        title: 'An article',
        tags: ['fitness', 'article'],
      },
      {
        title: 'Club',
        tags: ['fitness', 'club'],
      },
      {
        title: 'Coach',
        tags: ['fitness', 'coach'],
      },
      {
        title: 'Core strength check-in',
        tags: ['fitness', 'check-in', 'core strength'],
      },
      {
        title: 'Exercise routine',
        tags: ['fitness', 'exercise routine'],
      },
      {
        title: 'Fitness check-in',
        tags: ['fitness', 'check-in'],
      },
      {
        title: 'Fitness practice',
        tags: ['fitness', 'practice'],
      },
      {
        title: 'Inspiration',
        tags: ['fitness', 'inspiration'],
      },
      {
        title: 'Mentor',
        tags: ['fitness', 'mentor'],
      },
      {
        title: 'My sport',
        tags: ['fitness', 'my sport'],
      },
      {
        title: 'My sports team',
        tags: ['fitness', 'sports team'],
      },
      {
        title: 'Teammate',
        tags: ['fitness', 'teammate'],
      },
      {
        title: 'Timed run',
        tags: ['fitness', 'time'],
      },
      {
        title: 'Trainer',
        tags: ['fitness', 'trainer'],
      },
      {
        title: 'Weight training',
        tags: ['fitness', 'weight training'],
      },
      {
        title: 'What works for my fitness',
        tags: ['fitness', 'works'],
      },
      {
        title: 'When I trained for a fitness goal',
        tags: ['fitness', 'training'],
      },
      {
        title: 'Workout partner',
        tags: ['fitness', 'workout partner'],
      },
    ],
  },
  {
    name: 'Growth',
    IdeaIcon: 'growth',
    description:
      'The experiences, places, and people that make a difference in your emotional growth and mental health. This area is a really personal one ' +
      'so be creative and make it work for you!',
    ideas: [
      {
        title: 'Growth',
        tags: ['growth'],
      },
      {
        title: 'Emotional growth',
        tags: ['growth', 'emotional growth'],
      },
      {
        title: 'A book',
        tags: ['growth', 'book'],
      },
      {
        title: 'A growth opportunity',
        tags: ['growth', 'opportunity'],
      },
      {
        title: 'A growth practice',
        tags: ['growth', 'practice'],
      },
      {
        title: 'A person that inspires me',
        tags: ['growth', 'inspiration'],
      },
      {
        title: 'A person that supports me',
        tags: ['growth', 'support'],
      },
      {
        title: 'A quote',
        tags: ['growth', 'quote'],
      },
      {
        title: 'A relapse',
        tags: ['growth', 'relapse'],
      },
      {
        title: 'A resource',
        tags: ['growth', 'resource'],
      },
      {
        title: 'A setback',
        tags: ['growth', 'setback'],
      },
      {
        title: 'An affirmation',
        tags: ['growth', 'affirmation'],
      },
      {
        title: 'An article',
        tags: ['growth', 'article'],
      },
      {
        title: 'Check-in - my mental health',
        tags: ['growth', 'check-in', 'mental health'],
      },
      {
        title: 'Core assets - belonging',
        tags: ['growth', 'core assets', 'belonging'],
      },
      {
        title: 'Core assets - growth-mindset',
        tags: ['growth', 'core assets', 'growth-mindset'],
      },
      {
        title: 'Core assets - hope',
        tags: ['growth', 'core assets', 'hope'],
      },
      {
        title: 'Core assets - perseverance and grit',
        tags: ['growth', 'core assets', 'perseverance & grit'],
      },
      {
        title: 'Core assets - positive relationship building',
        tags: ['growth', 'core assets', 'positive relationships building'],
      },
      {
        title: 'Core assets - problem-solving',
        tags: ['growth', 'core assets', 'problem-solving'],
      },
      {
        title: 'Core assets - self-management',
        tags: ['growth', 'core assets', 'self-management'],
      },
      {
        title: 'Core assets - self-determination',
        tags: ['growth', 'core assets', 'self-determination'],
      },
      {
        title: 'Core assets - spark',
        tags: ['growth', 'core assets', 'spark'],
      },
      {
        title: 'Creativity',
        tags: ['growth', 'creativity'],
      },
      {
        title: 'Grit',
        tags: ['growth', 'grit'],
      },
      {
        title: 'Growth-mindset',
        tags: ['growth', 'growth-mindset'],
      },
      {
        title: 'Hope',
        tags: ['growth', 'hope'],
      },
      {
        title: "I'm grateful for...",
        tags: ['growth', 'gratitude'],
      },
      {
        title: "I'm paying attention to this emotion...",
        tags: ['growth', 'emotion'],
      },
      {
        title: "I'm working on...",
        tags: ['growth'],
      },
      {
        title: 'Inspiration',
        tags: ['growth', 'inspiration'],
      },
      {
        title: 'Medication that supports my emotional health',
        tags: ['growth', 'medication'],
      },
      {
        title: 'My mindfulness practice',
        tags: ['growth', 'mindfulness'],
      },
      {
        title: 'Therapist',
        tags: ['growth', 'therapist'],
      },
      {
        title: 'Perseverance',
        tags: ['growth', 'perseverance'],
      },
      {
        title: 'Problem-solving',
        tags: ['growth', 'problem-solving'],
      },
      {
        title: 'Psychiatrist',
        tags: ['growth', 'psychiatrist'],
      },
      {
        title: 'Psychologist',
        tags: ['growth', 'psychologist'],
      },
      {
        title: 'Reflection',
        tags: ['growth', 'reflection'],
      },
      {
        title: 'Self-determination',
        tags: ['growth', 'self-determination'],
      },
      {
        title: 'Self-efficacy',
        tags: ['growth', 'self-efficacy'],
      },
      {
        title: 'Self-management',
        tags: ['growth', 'self-management'],
      },
      {
        title: 'Sobriety path',
        tags: ['growth', 'sobriety'],
      },
      {
        title: 'Something that comforts me',
        tags: ['growth', 'comfort'],
      },
      {
        title: 'Something that encourages me',
        tags: ['growth', 'encouragement'],
      },
      {
        title: 'Something that motivates me',
        tags: ['growth', 'motivation'],
      },
      {
        title: 'Spark',
        tags: ['growth', 'spark'],
      },
      {
        title: 'Support',
        tags: ['growth', 'support'],
      },
      {
        title: 'Therapy',
        tags: ['growth', 'therapy'],
      },
      {
        title: 'Treatment',
        tags: ['growth', 'treatment'],
      },
    ],
  },
  {
    name: 'Hardships',
    IdeaIcon: 'hardships',
    description:
      'Life is wonderful but, let’s face it, life is also hard. Here is a place to record those hardships. How have you suffered, and have you ' +
      'suffered wisely? What losses have you had? When and why have you grieved? Share the mistakes you’ve made and how you have contributed to ' +
      'your own suffering. What have others done to hurt you? What challenges, little or large, are you facing? How are you growing through them?',
    ideas: [
      {
        title: 'A hardship',
        tags: ['hardships'],
      },
      {
        title: 'A barrier',
        tags: ['hardships', 'barrier'],
      },
      {
        title: 'A betrayal of trust',
        tags: ['hardships', 'betrayal'],
      },
      {
        title: 'A challenge',
        tags: ['hardships', 'challenge'],
      },
      {
        title: 'A community hardship',
        tags: ['hardships', 'community'],
      },
      {
        title: 'A death',
        tags: ['hardships', 'death'],
      },
      {
        title: 'A diagnosis',
        tags: ['hardships', 'diagnosis'],
      },
      {
        title: 'A disaster',
        tags: ['hardships', 'disaster'],
      },
      {
        title: 'A divorce',
        tags: ['hardships', 'divorce'],
      },
      {
        title: 'A domestic hardship',
        tags: ['hardships', 'domestic'],
      },
      {
        title: 'A family hardship',
        tags: ['hardships', 'family'],
      },
      {
        title: 'A financial hardship',
        tags: ['hardships', 'financial'],
      },
      {
        title: 'A friend hardship',
        tags: ['hardships', 'friend'],
      },
      {
        title: 'A job loss',
        tags: ['hardships', 'job loss'],
      },
      {
        title: 'A loss',
        tags: ['hardships', 'loss'],
      },
      {
        title: 'A mistake',
        tags: ['hardships', 'mistake'],
      },
      {
        title: 'A national hardship',
        tags: ['hardships', 'national'],
      },
      {
        title: 'A relapse',
        tags: ['hardships', 'relapse'],
      },
      {
        title: 'A relationship struggle',
        tags: ['hardships', 'relationship struggle'],
      },
      {
        title: 'A set-back',
        tags: ['hardships', 'setback'],
      },
      {
        title: 'A suicide',
        tags: ['hardships', 'suicide'],
      },
      {
        title: 'A suicide attempt',
        tags: ['hardships', 'suicide attempt'],
      },
      {
        title: 'A trauma',
        tags: ['hardships', 'trauma'],
      },
      {
        title: 'A worldwide hardship',
        tags: ['hardships', 'world'],
      },
      {
        title: 'An accident',
        tags: ['hardships', 'accident'],
      },
      {
        title: 'An illness',
        tags: ['hardships', 'illness'],
      },
      {
        title: 'An injustice',
        tags: ['hardships', 'injustice'],
      },
      {
        title: "How I've grown through a hardship",
        tags: ['hardships', 'growth'],
      },
      {
        title: 'I live with...',
        tags: ['hardships'],
      },
      {
        title: 'I suffer from...',
        tags: ['hardships'],
      },
      {
        title: 'I suffered',
        tags: ['hardships', 'suffering'],
      },
      {
        title: 'I suffered wisely',
        tags: ['hardships', 'suffering wisely'],
      },
      {
        title: "I'm recovering from...",
        tags: ['hardships'],
      },
      {
        title: 'Mental illness',
        tags: ['hardships', 'mental illness'],
      },
      {
        title: "My child's mental illness",
        tags: ['hardships', 'mental illness'],
      },
      {
        title: "My friend's mental illness",
        tags: ['hardships', 'mental illness'],
      },
      {
        title: 'My mental illness',
        tags: ['hardships', 'mental illness'],
      },
      {
        title: "My parent's mental illness",
        tags: ['hardships', 'mental illness'],
      },
      {
        title: 'Political unrest',
        tags: ['hardships', 'political unrest'],
      },
      {
        title: 'Prejudice',
        tags: ['hardships', 'prejudice'],
      },
      {
        title: 'Racism',
        tags: ['hardships', 'racism'],
      },
      {
        title: 'Sexism',
        tags: ['hardships', 'sexism'],
      },
      {
        title: 'Social unrest',
        tags: ['hardships', 'social unrest'],
      },
      {
        title: 'Substance abuse',
        tags: ['hardships', 'substance abuse'],
      },
      {
        title: 'Violence',
        tags: ['hardships', 'violence'],
      },
    ],
  },
  {
    name: 'Health',
    IdeaIcon: 'health',
    description:
      'Anything that would go into your health file - immunizations, injuries, diagnoses, and health checks as well as solutions, practices, ' +
      'tools and life changes that help you stay healthy and strong.',
    ideas: [
      {
        title: 'Health',
        tags: ['health'],
      },
      {
        title: 'A book',
        tags: ['health', 'book'],
      },
      {
        title: 'A change in my health',
        tags: ['health', 'change'],
      },
      {
        title: 'A doctor appointment',
        tags: ['health', 'appointment'],
      },
      {
        title: 'Alcohol use',
        tags: ['health', 'alcohol'],
      },
      {
        title: 'An article',
        tags: ['health', 'article'],
      },
      {
        title: 'Blood pressure',
        tags: ['health', 'blood pressure'],
      },
      {
        title: 'Blood sugar',
        tags: ['health', 'blood sugar'],
      },
      {
        title: 'Check up',
        tags: ['health', 'check up'],
      },
      {
        title: 'Dentist',
        tags: ['health', 'dentist'],
      },
      {
        title: 'Diagnosis',
        tags: ['health', 'diagnosis'],
      },
      {
        title: 'Doctor',
        tags: ['health', 'doctor'],
      },
      {
        title: 'Drug use',
        tags: ['health', 'drug use'],
      },
      {
        title: 'Eyes',
        tags: ['health', 'eyes'],
      },
      {
        title: 'Gun safety',
        tags: ['health', 'gun safety'],
      },
      {
        title: 'Health care company',
        tags: ['health', 'health care company'],
      },
      {
        title: 'Health condition',
        tags: ['health', 'condition'],
      },
      {
        title: 'Health insurance',
        tags: ['health', 'health insurance'],
      },
      {
        title: 'Health question',
        tags: ['health', 'question'],
      },
      {
        title: 'Health setback',
        tags: ['health', 'setback'],
      },
      {
        title: 'Health test',
        tags: ['health', 'test'],
      },
      {
        title: 'Health update',
        tags: ['health', 'update'],
      },
      {
        title: 'Hospital',
        tags: ['health', 'hospital'],
      },
      {
        title: 'Immunization report',
        tags: ['health', 'immunization report'],
      },
      {
        title: 'Immunization to do',
        tags: ['health', 'immunization', 'to do'],
      },
      {
        title: 'Injury',
        tags: ['health', 'injury'],
      },
      {
        title: 'Medications',
        tags: ['health', 'medications'],
      },
      {
        title: 'Nutrition',
        tags: ['health', 'nutrition'],
      },
      {
        title: 'Practice that helps my health',
        tags: ['health', 'practice'],
      },
      {
        title: 'Safe home check',
        tags: ['health', 'safe home check'],
      },
      {
        title: 'Safety plan',
        tags: ['health', 'safety plan'],
      },
      {
        title: 'Sickness',
        tags: ['health', 'sickness'],
      },
      {
        title: 'Skin routine',
        tags: ['health', 'skin'],
      },
      {
        title: 'Sleep',
        tags: ['health', 'sleep'],
      },
      {
        title: 'Smoking',
        tags: ['health', 'smoking'],
      },
      {
        title: 'Solution',
        tags: ['health', 'solution'],
      },
      {
        title: 'Stress level',
        tags: ['health', 'stress level'],
      },
      {
        title: 'Teeth',
        tags: ['health', 'teeth'],
      },
      {
        title: 'Test results',
        tags: ['health', 'test results'],
      },
      {
        title: 'Vitamins',
        tags: ['health', 'vitamins'],
      },
      {
        title: 'Weight',
        tags: ['health', 'weight'],
      },
    ],
  },
  {
    name: 'Journeys',
    IdeaIcon: 'journeys',
    description:
      'Describe the journeys you have taken - the travels, adventures, pilgrimages and passages that have been part of your life. How has your ' +
      'life, your world view, and your perspective changed, grown, expanded?',
    ideas: [
      {
        title: 'A journey',
        tags: ['journeys'],
      },
      {
        title: 'Adventure',
        tags: ['journeys', 'adventure'],
      },
      {
        title: 'Beach trip',
        tags: ['journeys', 'beach'],
      },
      {
        title: 'Bucket list',
        tags: ['journeys', 'bucketlist'],
      },
      {
        title: 'Camping',
        tags: ['journeys', 'camping'],
      },
      {
        title: 'Destination',
        tags: ['journeys', 'destination'],
      },
      {
        title: 'Discovery',
        tags: ['journeys', 'discovery'],
      },
      {
        title: 'Drive',
        tags: ['journeys', 'drive'],
      },
      {
        title: 'Family vacation',
        tags: ['journeys', 'family vacation'],
      },
      {
        title: 'Flight',
        tags: ['journeys', 'flight'],
      },
      {
        title: 'Get-away',
        tags: ['journeys', 'getaway'],
      },
      {
        title: 'Hike',
        tags: ['journeys', 'hike'],
      },
      {
        title: 'Hotel',
        tags: ['journeys', 'hotel'],
      },
      {
        title: 'Itinerary',
        tags: ['journeys', 'itinerary'],
      },
      {
        title: 'Journey challenge',
        tags: ['journeys', 'challenge'],
      },
      {
        title: 'Journey funny moment',
        tags: ['journeys', 'funny'],
      },
      {
        title: 'Journey location',
        tags: ['journeys', 'location'],
      },
      {
        title: 'Journey memory',
        tags: ['journeys', 'memory'],
      },
      {
        title: 'Journey resource',
        tags: ['journeys', 'resource'],
      },
      {
        title: 'Local adventure',
        tags: ['journeys', 'local adventure'],
      },
      {
        title: 'My journey taught me...',
        tags: ['journeys', 'lesson'],
      },
      {
        title: 'Outing',
        tags: ['journeys', 'outing'],
      },
      {
        title: 'Passage',
        tags: ['journeys', 'passage'],
      },
      {
        title: 'Pilgrimage',
        tags: ['journeys', 'pilgrimage'],
      },
      {
        title: 'Pitstop',
        tags: ['journeys', 'pitstop'],
      },
      {
        title: 'Road trip',
        tags: ['journeys', 'road trip'],
      },
      {
        title: 'Staycation',
        tags: ['journeys', 'staycation'],
      },
      {
        title: 'Summer vacation',
        tags: ['journeys', 'summer vacation'],
      },
      {
        title: 'Travel abroad',
        tags: ['journeys', 'travel abroad'],
      },
      {
        title: 'Trip',
        tags: ['journeys', 'trip'],
      },
      {
        title: 'Vacation',
        tags: ['journeys', 'vacation'],
      },
      {
        title: 'Vacation with friends',
        tags: ['journeys', 'friends vacation'],
      },
      {
        title: 'Visit',
        tags: ['journeys', 'visit'],
      },
      {
        title: 'Voyage',
        tags: ['journeys', 'voyage'],
      },
      {
        title: 'Walk',
        tags: ['journeys', 'walk'],
      },
      {
        title: 'Work trip',
        tags: ['journeys', 'work trip'],
      },
    ],
  },
  {
    name: 'Learning',
    IdeaIcon: 'learning',
    description:
      'Your schools, for sure, but also classes, camps, skills, and ideas along with the people that’ve helped you learn. Also pay attention to ' +
      'your informal, unstructured learning - what you learn from your family, heritage, friends and even yourself. Include anything that would ' +
      'go into your learning portfolio.',
    ideas: [
      {
        title: 'Learning',
        tags: ['learning'],
      },
      {
        title: 'A book',
        tags: ['learning', 'book'],
      },
      {
        title: 'A camp',
        tags: ['learning', 'camp'],
      },
      {
        title: 'A class',
        tags: ['learning', 'class'],
      },
      {
        title: 'A class I loved',
        tags: ['learning', 'class'],
      },
      {
        title: 'A learning experience',
        tags: ['learning', 'experience'],
      },
      {
        title: 'A movie',
        tags: ['learning', 'movie'],
      },
      {
        title: 'A museum',
        tags: ['learning', 'museum'],
      },
      {
        title: 'A professor that challenged me',
        tags: ['learning', 'professor'],
      },
      {
        title: 'a skill',
        tags: ['learning', 'skill'],
      },
      {
        title: 'A theory that interests me',
        tags: ['learning', 'theory'],
      },
      {
        title: 'An article',
        tags: ['learning', 'article'],
      },
      {
        title: 'An award',
        tags: ['learning', 'award'],
      },
      {
        title: "An idea/subject I'm studying",
        tags: ['learning', 'idea'],
      },
      {
        title: 'An important class',
        tags: ['learning', 'class'],
      },
      {
        title: 'an unexpected learning moment',
        tags: ['learning', 'unexpected'],
      },
      {
        title: 'Art',
        tags: ['learning', 'art'],
      },
      {
        title: 'College',
        tags: ['learning', 'college'],
      },
      {
        title: 'College major',
        tags: ['learning', 'college major'],
      },
      {
        title: 'College minor',
        tags: ['learning', 'college minor'],
      },
      {
        title: 'Elementary school',
        tags: ['learning', 'elementary school'],
      },
      {
        title: 'Extracurricular learning',
        tags: ['learning', 'extracurricular'],
      },
      {
        title: 'GED',
        tags: ['learning', 'ged'],
      },
      {
        title: 'Graduate school',
        tags: ['learning', 'graduate school'],
      },
      {
        title: 'High school',
        tags: ['learning', 'high school'],
      },
      {
        title: 'I love learning about...',
        tags: ['learning'],
      },
      {
        title: 'I want to learn to...',
        tags: ['learning'],
      },
      {
        title: "I'm learning...",
        tags: ['learning'],
      },
      {
        title: 'Informal learning',
        tags: ['learning'],
      },
      {
        title: 'Inspiring projects',
        tags: ['learning', 'inspiring'],
      },
      {
        title: 'Language learning',
        tags: ['learning', 'language'],
      },
      {
        title: 'Learning about my heritage',
        tags: ['learning', 'heritage'],
      },
      {
        title: 'Learning challenge',
        tags: ['learning', 'challenge'],
      },
      {
        title: 'Learning strength',
        tags: ['learning', 'strength'],
      },
      {
        title: 'Learning style',
        tags: ['learning', 'style'],
      },
      {
        title: 'Library',
        tags: ['learning', 'library'],
      },
      {
        title: 'Middle school',
        tags: ['learning', 'middle school'],
      },
      {
        title: 'Music',
        tags: ['learning', 'music'],
      },
      {
        title: 'My favorite subject is...',
        tags: ['learning', 'favorite subject'],
      },
      {
        title: 'Preschool',
        tags: ['learning', 'preschool'],
      },
      {
        title: 'Subject',
        tags: ['learning', 'subject'],
      },
      {
        title: 'Teacher',
        tags: ['learning', 'teacher'],
      },
      {
        title: 'Trade school',
        tags: ['learning', 'trade school'],
      },
    ],
  },
  {
    name: 'Moments',
    IdeaIcon: 'moments',
    description:
      'The small but significant moments of your life - fun times with friends, daily and regular activities that matter to you, small rituals, ' +
      'and little memories that add up to make the life that YOU live meaningful.',
    ideas: [
      {
        title: 'A moment',
        tags: ['moments'],
      },
      {
        title: 'A daily ritual',
        tags: ['moments', 'daily ritual'],
      },
      {
        title: 'A date we went on',
        tags: ['moments', 'date'],
      },
      {
        title: 'A family ritual',
        tags: ['moments', 'family ritual'],
      },
      {
        title: 'A gift',
        tags: ['moments', 'gift'],
      },
      {
        title: 'A good memory',
        tags: ['moments', 'good memory'],
      },
      {
        title: 'A happy moment',
        tags: ['moments', 'happy'],
      },
      {
        title: 'A meal',
        tags: ['moments', 'meal'],
      },
      {
        title: 'A memory',
        tags: ['moments', 'memory'],
      },
      {
        title: 'A moment at home',
        tags: ['moments', 'home'],
      },
      {
        title: 'A moment that meant a lot to me',
        tags: ['moments', 'meaningful'],
      },
      {
        title: 'A moment that meant a lot to us',
        tags: ['moments', 'meaningful'],
      },
      {
        title: 'A weekly ritual',
        tags: ['moments', 'weekly ritual'],
      },
      {
        title: 'An act of kindness',
        tags: ['moments', 'act of kindness'],
      },
      {
        title: 'An outing',
        tags: ['moments', 'outing'],
      },
      {
        title: 'Friend time',
        tags: ['moments', 'friend'],
      },
      {
        title: 'Fun',
        tags: ['moments', 'fun'],
      },
      {
        title: 'Hanging out',
        tags: ['moments', 'hanging out'],
      },
      {
        title: 'I spend time...',
        tags: ['moments'],
      },
      {
        title: 'We spend time...',
        tags: ['moments', 'together-time'],
      },
    ],
  },
  {
    name: 'Places',
    IdeaIcon: 'places',
    description:
      'A place that is important to you, where you live or have lived, where you’ve gone, where you want to go, a place that means a lot to you.',
    ideas: [
      {
        title: 'A place',
        tags: ['places'],
      },
      {
        title: 'A place I find adventure',
        tags: ['places', 'adventure'],
      },
      {
        title: 'A place I find peace',
        tags: ['places', 'peace'],
      },
      {
        title: 'A place I love',
        tags: ['places'],
      },
      {
        title: 'A place I want to visit',
        tags: ['places', 'i want to visit'],
      },
      {
        title: "A place I've visited",
        tags: ['places', 'visited'],
      },
      {
        title: 'A place that feels like home',
        tags: ['places', 'home'],
      },
      {
        title: 'A place that means a lot to me',
        tags: ['places', 'meaningful'],
      },
      {
        title: 'A safe space',
        tags: ['places', 'safe'],
      },
      {
        title: 'A vacation spot',
        tags: ['places', 'vacation'],
      },
      {
        title: 'City I love',
        tags: ['places', 'city'],
      },
      {
        title: 'State I love',
        tags: ['places', 'state'],
      },
      {
        title: 'Country I love',
        tags: ['places', 'country'],
      },
      {
        title: 'Current address',
        tags: ['places', 'address'],
      },
      {
        title: 'Old address',
        tags: ['places', 'old address'],
      },
      {
        title: 'Home',
        tags: ['places', 'home'],
      },
      {
        title: 'Home I used to live in',
        tags: ['places', 'home', 'where i have lived'],
      },
      {
        title: 'I lived here',
        tags: ['places', 'where i have lived'],
      },
      {
        title: 'Places on my bucket list',
        tags: ['places', 'bucket list'],
      },
      {
        title: 'Places on my bucket list I have gone to',
        tags: ['places', 'bucket list ✓'],
      },
      {
        title: "Relative's home",
        tags: ['places', 'family'],
      },
    ],
  },
  {
    name: 'Purpose',
    IdeaIcon: 'purpose',
    description:
      'What inspires you, bugs you, matters and bring meaning to you? In your community, your state, your country, your world, what causes do ' +
      'you care about and changes do you want to be part of? Keep track of problems and solutions and your own involvement in them. Sharing ' +
      'these as a family will help you know how to support each others’ passions and life purpose.',
    ideas: [
      {
        title: 'Purpose',
        tags: ['purpose'],
      },
      {
        title: 'A purpose',
        tags: ['purpose'],
      },
      {
        title: 'A book',
        tags: ['purpose', 'book'],
      },
      {
        title: 'A cause I believe in',
        tags: ['purpose', 'cause'],
      },
      {
        title: 'A cause my family is involved in',
        tags: ['purpose', 'cause', 'family'],
      },
      {
        title: 'A community issue I care about',
        tags: ['purpose', 'community', 'issue'],
      },
      {
        title: 'A global issue I care about ',
        tags: ['purpose', 'global', 'issue'],
      },
      {
        title: 'A hobby',
        tags: ['purpose', 'hobby'],
      },
      {
        title: 'A movie',
        tags: ['purpose', 'movie'],
      },
      {
        title: 'A need in the world I want to help with',
        tags: ['purpose', 'world-need'],
      },
      {
        title: 'A passion',
        tags: ['purpose', 'passion'],
      },
      {
        title: 'A person who inspires my purpose',
        tags: ['purpose', 'inspiration'],
      },
      {
        title: 'A person who supports me fulfilling my purpose',
        tags: ['purpose', 'support'],
      },
      {
        title: 'A problem I want to solve',
        tags: ['purpose', 'problem to solve'],
      },
      {
        title: "A purpose-oriented group I'm part of",
        tags: ['purpose', 'group'],
      },
      {
        title: 'A quote',
        tags: ['purpose', 'quote'],
      },
      {
        title: 'A resource',
        tags: ['purpose', 'resource'],
      },
      {
        title: 'A solution',
        tags: ['purpose', 'solution'],
      },
      {
        title: 'A time I used my gifts and talents',
        tags: ['purpose', 'gifts and talents ✓'],
      },
      {
        title: 'An act of activism',
        tags: ['purpose', 'activism'],
      },
      {
        title: 'An act of joy',
        tags: ['purpose', 'act of joy'],
      },
      {
        title: 'An act of service',
        tags: ['purpose', 'act of service'],
      },
      {
        title: "An action I'm / we're taking to make the world better",
        tags: ['purpose', 'better world'],
      },
      {
        title: 'An activity in my life that makes me feel alive',
        tags: ['purpose', 'alive'],
      },
      {
        title: 'An article',
        tags: ['purpose', 'article'],
      },
      {
        title: "An earth-friendly action I'm/we're taking",
        tags: ['purpose', 'earth-friendly'],
      },
      {
        title: 'An interest',
        tags: ['purpose', 'interest'],
      },
      {
        title: 'An issue I want to learn more about',
        tags: ['purpose', 'issue'],
      },
      {
        title: 'An organization I am part of',
        tags: ['purpose', 'organization'],
      },
      {
        title: 'Gifts and talents people have said they see in me',
        tags: ['purpose', 'gifts and talents'],
      },
      {
        title: 'I volunteered for...',
        tags: ['purpose', 'volunteer'],
      },
      {
        title: 'I voted for...',
        tags: ['purpose', 'vote'],
      },
      {
        title: "I'm excited to be part of...",
        tags: ['purpose'],
      },
      {
        title: 'I/we give money to...',
        tags: ['purpose', 'financial support'],
      },
      {
        title: 'I/we support...',
        tags: ['purpose', 'support'],
      },
      {
        title: 'My spark',
        tags: ['purpose', 'spark'],
      },
      {
        title: 'My vocation',
        tags: ['purpose', 'vocation'],
      },
      {
        title: 'Something that bugs me about how the world is',
        tags: ['purpose', 'what bugs me'],
      },
      {
        title: 'What I feel called to do in my life',
        tags: ['purpose', 'calling'],
      },
    ],
  },
  {
    name: 'Relationships',
    IdeaIcon: 'relationships',
    description:
      'Relationships: Anyone who has been and is important to you. Also track how well your relationships are doing over time. Use the check-in ' +
      'to record moments of struggle, joy, forgiveness and more.',
    ideas: [
      {
        title: 'A relationship',
        tags: ['relationships'],
      },
      {
        title: 'Relationship check-in',
        tags: ['relationships', 'check-in'],
      },
      {
        title: 'A change in my/our relationship',
        tags: ['relationships', 'change'],
      },
      {
        title: 'A family strength',
        tags: ['relationships', 'family strengths'],
      },
      {
        title: 'A family struggle',
        tags: ['relationships', 'family struggle'],
      },
      {
        title: 'A family that is important to me',
        tags: ['relationships', 'family'],
      },
      {
        title: 'A milestone in my/our relationship',
        tags: ['relationships', 'milestone'],
      },
      {
        title: 'A person that supports my having healthy relationships',
        tags: ['relationships', 'healthy', 'support'],
      },
      {
        title: "A relationship skill I'm practicing",
        tags: ['relationships', 'skill'],
      },
      {
        title: 'A strength in my/our relationship',
        tags: ['relationships', 'strengths'],
      },
      {
        title: 'An activity that we did together',
        tags: ['relationships', 'activity'],
      },
      {
        title: 'Belonging',
        tags: ['relationships', 'belonging'],
      },
      {
        title: 'Fun memories in our relationship',
        tags: ['relationships', 'fun'],
      },
      {
        title: 'Highlights of our relationship',
        tags: ['relationships', 'highlights'],
      },
      {
        title: 'Hurt in our relationship',
        tags: ['relationships', 'hurt'],
      },
      {
        title: 'Aquaintance',
        tags: ['relationships', 'acquaintance'],
      },
      {
        title: 'Ancestor',
        tags: ['relationships', 'ancestor'],
      },
      {
        title: 'Assistant',
        tags: ['relationships', 'assistant'],
      },
      {
        title: 'Aunt',
        tags: ['relationships', 'aunt'],
      },
      {
        title: 'Boss',
        tags: ['relationships', 'boss'],
      },
      {
        title: 'Brother',
        tags: ['relationships', 'brother'],
      },
      {
        title: 'Child',
        tags: ['relationships', 'child'],
      },
      {
        title: 'Close friend',
        tags: ['relationships', 'close.friend'],
      },
      {
        title: 'Coach',
        tags: ['relationships', 'coach'],
      },
      {
        title: 'Colleague',
        tags: ['relationships', 'coleague'],
      },
      {
        title: 'Dad',
        tags: ['relationships', 'dad'],
      },
      {
        title: 'Daughter',
        tags: ['relationships', 'daughter'],
      },
      {
        title: 'Extended family member',
        tags: ['relationships', 'extended family'],
      },
      {
        title: 'Friend',
        tags: ['relationships', 'friend'],
      },
      {
        title: 'Grandma',
        tags: ['relationships', 'grandma'],
      },
      {
        title: 'Grandpa',
        tags: ['relationships', 'grandpa'],
      },
      {
        title: 'Manager',
        tags: ['relationships', 'manager'],
      },
      {
        title: 'Mentor',
        tags: ['relationships', 'mentor'],
      },
      {
        title: 'Mom',
        tags: ['relationships', 'mom'],
      },
      {
        title: 'Nephew',
        tags: ['relationships', 'nephew'],
      },
      {
        title: 'Parent',
        tags: ['relationships', 'parent'],
      },
      {
        title: 'Partner',
        tags: ['relationships', 'partner'],
      },
      {
        title: 'Pet',
        tags: ['relationships', 'pet'],
      },
      {
        title: 'Roommate/housemate',
        tags: ['relationships', 'roommate/housemate'],
      },
      {
        title: 'Sibling',
        tags: ['relationships', 'sibling'],
      },
      {
        title: 'Significant other',
        tags: ['relationships', 'significant.other'],
      },
      {
        title: 'Sister',
        tags: ['relationships', 'sister'],
      },
      {
        title: 'Son',
        tags: ['relationships', 'son'],
      },
      {
        title: 'Spouse',
        tags: ['relationships', 'spouse'],
      },
      {
        title: 'Teacher',
        tags: ['relationships', 'teacher'],
      },
      {
        title: 'Uncle',
        tags: ['relationships', 'uncle'],
      },
      {
        title: 'Family friend',
        tags: ['relationships', 'family friend'],
      },
      {
        title: 'Family friends',
        tags: ['relationships', 'family friends'],
      },
      {
        title: 'Positive relationship building',
        tags: ['relationships', 'positive relationship building'],
      },
      {
        title: 'Relationship ended',
        tags: ['relationships', 'relationship ended'],
      },
      {
        title: 'Relationship goals',
        tags: ['relationships', 'goals'],
      },
      {
        title: 'Relationship resource',
        tags: ['relationships', 'resource'],
      },
      {
        title: 'What I admire about...',
        tags: ['relationships', 'admire'],
      },
      {
        title: "What we're working on in our relationship",
        tags: ['relationships', 'growth'],
      },
    ],
  },
  {
    name: 'Spirituality',
    IdeaIcon: 'spirituality',
    description:
      'Your spiritual life is what is most profound to you - your Ultimate Concern. You can use this space to pay attention to your spiritual ' +
      'growth and what impacts you spiritually. What do you believe? Where and when do you worship? What nurtures your spirit, your sense of ' +
      'awe? Who are the people and environments that help you be the best version of you? Your experience with transcendence (your Higher Power) ' +
      'AND your response to that experience - what you value most, find most profound, the actions you take that either align (or don’t) to the ' +
      'person you want to be and become.',
    ideas: [
      {
        title: 'Spirituality',
        tags: ['spirituality'],
      },
      {
        title: 'Spiritual growth',
        tags: ['spirituality', 'growth'],
      },
      {
        title: 'A book',
        tags: ['spirituality', 'book'],
      },
      {
        title: 'A change in what I believe',
        tags: ['spirituality', 'belief'],
      },
      {
        title: 'A defining decision reflecting the person I want to be',
        tags: ['spirituality', 'decision'],
      },
      {
        title: 'A life-giving moment',
        tags: ['spirituality', 'life-giving'],
      },
      {
        title: 'A meaningful spiritual event',
        tags: ['spirituality', 'event'],
      },
      {
        title: 'A place I feel especially alive',
        tags: ['spirituality', 'alive'],
      },
      {
        title: 'A prayer',
        tags: ['spirituality', 'prayer'],
      },
      {
        title: 'A quote',
        tags: ['spirituality', 'quote'],
      },
      {
        title: 'A religious ceremony',
        tags: ['spirituality', 'ceremony'],
      },
      {
        title: 'A religious season',
        tags: ['spirituality', 'religious season'],
      },
      {
        title: 'A ritual',
        tags: ['spirituality', 'ritual'],
      },
      {
        title: 'A sacred place',
        tags: ['spirituality', 'sacred place'],
      },
      {
        title: 'A song that inpires me',
        tags: ['spirituality', 'song'],
      },
      {
        title: 'A spiritual discipline',
        tags: ['spirituality', 'spiritual discipline'],
      },
      {
        title: 'A spiritual injury',
        tags: ['spirituality', 'injury'],
      },
      {
        title: 'A spiritual lesson',
        tags: ['spirituality', 'lesson'],
      },
      {
        title: 'A spiritual practice',
        tags: ['spirituality', 'practice'],
      },
      {
        title: 'A spiritual set-back',
        tags: ['spirituality', 'set-back'],
      },
      {
        title: 'A step in my spiritual journey',
        tags: ['spirituality', 'journey'],
      },
      {
        title: 'A time I experienced grace',
        tags: ['spirituality', 'grace'],
      },
      {
        title: 'A time when I forgave someone',
        tags: ['spirituality', 'forgiveness'],
      },
      {
        title: 'A time when I grew spiritually',
        tags: ['spirituality', 'growth'],
      },
      {
        title: 'A time when someone forgave me',
        tags: ['spirituality', 'forgiveness'],
      },
      {
        title: 'A verse',
        tags: ['spirituality', 'verse'],
      },
      {
        title: 'An article',
        tags: ['spirituality', 'article'],
      },
      {
        title: 'An opportunity for me to grow spiritually',
        tags: ['spirituality', 'growth'],
      },
      {
        title: 'Guide',
        tags: ['spirituality', 'guide'],
      },
      {
        title: "I'm praying for...",
        tags: ['spirituality', 'prayer'],
      },
      {
        title: 'Leader',
        tags: ['spirituality', 'leader'],
      },
      {
        title: 'Mentor',
        tags: ['spirituality', 'mentor'],
      },
      {
        title: 'My place of worship',
        tags: ['spirituality', 'worship'],
      },
      {
        title: 'My religion',
        tags: ['spirituality', 'religion'],
      },
      {
        title: "Nature's awe-someness",
        tags: ['spirituality', 'nature'],
      },
      {
        title: 'Religious leader',
        tags: ['spirituality', 'religious leader'],
      },
      {
        title: 'Teacher',
        tags: ['spirituality', 'teacher'],
      },
      {
        title: 'Ultimate Concern',
        tags: ['spirituality', 'ultimate concern'],
      },
      {
        title: 'What I believe now',
        tags: ['spirituality', 'belief'],
      },
    ],
  },
  {
    name: 'Work',
    IdeaIcon: 'work',
    description:
      'Your work life, paid and unpaid, past and present. Include the companies and organizations you’ve worked for; your projects, milestones, ' +
      'skills, colleagues; and the highlights and challenges of your life at work. Think of Riza as your tool to create an awesome portfolio and ' +
      'work history all your own.',
    ideas: [
      {
        title: 'Work',
        tags: ['work'],
      },
      {
        title: 'A book',
        tags: ['work', 'book'],
      },
      {
        title: 'A career I want to explore',
        tags: ['work', 'career'],
      },
      {
        title: 'A career I want to explore',
        tags: ['work', 'career'],
      },
      {
        title: 'A skill I use in my work',
        tags: ['work', 'skills'],
      },
      {
        title: 'A skill I want to develop',
        tags: ['work', 'skills'],
      },
      {
        title: 'A strength at work',
        tags: ['work', 'strengths'],
      },
      {
        title: 'A success',
        tags: ['work', 'success'],
      },
      {
        title: 'A training',
        tags: ['work', 'training'],
      },
      {
        title: 'A work goal',
        tags: ['work', 'goal'],
      },
      {
        title: 'An affirmation',
        tags: ['work', 'affirmation'],
      },
      {
        title: 'An article',
        tags: ['work', 'article'],
      },
      {
        title: 'An award',
        tags: ['work', 'award'],
      },
      {
        title: 'An internship',
        tags: ['work', 'internship'],
      },
      {
        title: 'An organizaiton I work with',
        tags: ['work', 'organzation'],
      },
      {
        title: 'Colleague',
        tags: ['work', 'colleague'],
      },
      {
        title: 'Company I work for',
        tags: ['work', 'company'],
      },
      {
        title: 'Continuing education for my work',
        tags: ['work', 'continuing education'],
      },
      {
        title: 'I volunteer at...',
        tags: ['work', 'volunteer'],
      },
      {
        title: 'I work for...',
        tags: ['work'],
      },
      {
        title: 'Inspiration',
        tags: ['work', 'inspiration'],
      },
      {
        title: 'Job',
        tags: ['work'],
      },
      {
        title: 'Mentor',
        tags: ['work', 'mentor'],
      },
      {
        title: 'My resume',
        tags: ['work', 'resume'],
      },
      {
        title: 'My vocation',
        tags: ['work', 'vocation'],
      },
      {
        title: 'My work aptitudes',
        tags: ['work', 'aptitudes'],
      },
      {
        title: 'Place I applied to',
        tags: ['work', 'application'],
      },
      {
        title: 'Put it on my resume',
        tags: ['work', 'resume'],
      },
      {
        title: 'Someone who supports me in my vocation',
        tags: ['work', 'support'],
      },
      {
        title: 'Something I want to work on to be excellent in my work',
        tags: ['work', 'excellence'],
      },
      {
        title: 'What I especially love about my work',
        tags: ['work', 'love'],
      },
      {
        title: 'Work challenges',
        tags: ['work', 'challenges'],
      },
      {
        title: 'Work contact',
        tags: ['work', 'contacts'],
      },
      {
        title: 'Work experience',
        tags: ['work', 'experience'],
      },
      {
        title: 'Work highlights',
        tags: ['work', 'highlights'],
      },
      {
        title: 'Work title',
        tags: ['work', 'title'],
      },
    ],
  },
  {
    name: 'Other',
    IdeaIcon: 'other',
    description: 'Here is a space to pay attention to something in your life that is unique and special to you, in a category all its own. ',
    ideas: [
      {
        title: 'Other',
        tags: ['other'],
      },
      {
        title: 'A book',
        tags: ['other', 'book'],
      },
      {
        title: 'A photo',
        tags: ['other', 'photo'],
      },
      {
        title: 'A quote',
        tags: ['other', 'quote'],
      },
      {
        title: 'A strength',
        tags: ['other', 'strengths'],
      },
      {
        title: 'a struggle',
        tags: ['other', 'struggle'],
      },
      {
        title: 'A success',
        tags: ['other', 'success'],
      },
      {
        title: 'A thing I want to track',
        tags: ['other'],
      },
      {
        title: 'An affirmation',
        tags: ['other', 'affirmation'],
      },
      {
        title: 'An article',
        tags: ['other', 'article'],
      },
      {
        title: 'Inspiration',
        tags: ['other', 'inspiration'],
      },
      {
        title: 'Random',
        tags: ['other', 'random'],
      },
      {
        title: 'Unique to me',
        tags: ['other', 'unique'],
      },
    ],
  },
];

export default [];
